// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase services
import { firebaseAuth } from '@/firebase/firebase-config'

export const ResidentsRepository = {

	/*
	**  Register the mixins
	*/

	mixins: [

		BugsnagService

	],

	/*
	**  Set up the data
	*/

	data: () => ({
        new_resident: {
			id: null,
			type: 'property.resident',
			meta: {
				created_at: moment().unix(),
				updated_at: moment().unix(),
				deleted_at: null,
				app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi'
			},
			attributes: {
				contact_information: {
					first_name: null,
					last_name: null,
					email: null,
					phone_number: null,
					address: {
						street_1: null,
						street_2: null,
						city: null,
						state: null,
						zip_code: null,
						country: 'US'
					},
					emergency: {
						name: null,
						relationship: null,
						phone_number: null,
						email: null
					}
				},
				unit: {
					resides_in: true,
					number: null
				},
				rent: {
					current: 0
				},
				notes: null,
				site_enrollment: {
					enroll_resident: false,
					send_email: false,
					enrollment_date: null
				},
				referral: {
					code: null,
					registered: false,
					date: null
				}
			},
			links: {
				avatar: null
			},
			relationships: {
				user: firebaseAuth.currentUser.uid,
				company: null,
				property: null,
				unit: null,
				lease: null,
				stripe: {
					customer: null,
					subscription: null,
					product: null,
					payment_method: null
				}
			}
		}
    }),

    /*
	**  Set the methods
	*/

	methods: {

        resetNewResidentProp: function() {

            try {

                /*
                **  Reset the prop
                **  @prop: @here
                */

                this.new_resident = {
                    id: null,
                    type: 'property.resident',
                    meta: {
                        created_at: moment().unix(),
                        updated_at: moment().unix(),
                        deleted_at: null,
                        app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi'
                    },
                    attributes: {
                        contact_information: {
                            first_name: null,
                            last_name: null,
                            email: null,
                            phone_number: null,
                            address: {
                                street_1: null,
                                street_2: null,
                                city: null,
                                state: null,
                                zip_code: null,
                                country: 'US'
                            },
                            emergency: {
                                name: null,
                                relationship: null,
                                phone_number: null,
                                email: null
                            }
                        },
                        unit: {
                            resides_in: true,
                            number: null
                        },
                        rent: {
                            current: 0
                        },
                        notes: null,
                        site_enrollment: {
                            enroll_resident: false,
                            send_email: false,
                            enrollment_date: null
                        },
                        referral: {
                            code: null,
                            registered: false,
                            date: null
                        }
                    },
                    links: {
                        avatar: null
                    },
                    relationships: {
                        user: firebaseAuth.currentUser.uid,
                        company: null,
                        property: null,
                        unit: null,
                        lease: null,
                        stripe: {
                            customer: null,
                            subscription: null,
                            product: null,
                            payment_method: null
                        }
                    }
                }

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Reset the new resident prop.',
                    errorType: 'Application',
                    section: 'Add Resident',
                    uid: 'ePlFdLKDRVDd7VipJXqs',
                    error: e
                });

            }

        }

    }

}